module.exports = __webpack_public_path__ + "static/media/neutral_slightly-sad.fc323048.svg";